import { RecaptchaProvider } from "./RecaptchaProvider";
import { McaptchaProvider } from "./McaptchaProvider";
import { AltchaProvider } from "./AltchaProvider";
import { TurnstileProvider } from "./TurnstileProvider";
import { ICaptchaProvider } from "./ICaptchaProvider";

export function resolveCaptchaProvider(): ICaptchaProvider {
  const active = window._env_?.CAPTCHA_ACTIVE?.toLowerCase();

  switch (active) {
    case "turnstile":
      return TurnstileProvider;
    case "altcha":
      return AltchaProvider;
    case "mcaptcha":
      return McaptchaProvider;
    case "recaptcha":
    default:
      return RecaptchaProvider;
  }
}
